import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import HomePage from "./components/homePage";
import ExploreDataManager from "./components/exploreDataManager";
import AddExploreDataForm from "./components/addExploreData";
import LiveStrategiesTable from "./components/liveStrategiesTable";
import StrategyDescriptionTable from "./components/strategyDescriptionTable";
import StrategyDataManager from "./components/strategyDataManager";
import NotificationDataManager from "./components/notificationDataManager";
import RefreshCache from "./components/refreshCache";
import StockSplitCalendar from "./components/StockSplitCalender";
import SchedulerAuditLogs from "./components/SchedulerAuditLog";
import AuditLogs from "./components/auditLogs";
import AuthPage from "./components/authPage";
import Logout from "./components/logout";
import UnauthorizedHomePage from "./components/unauthorizedHomePage";
import UnauthorizedExplorePage from "./components/unauthorizedExplorePage";
import UnauthorizedContactUs from "./components/unauthorizedContactUs";
import UnauthorizedAboutUs from "./components/unauthorizedAboutUs";
import UnauthorizedServicePage from "./components/unauthorizedService";
import SeeAllVideosPage from "./components/seeAllVideoPage";
import NewsLetterAndBlogs from "./components/newsLetterAndBlogs";
import NewsLetterAndBlogsTemplate from "./components/nesletterAndBlogsTemplate";
import AllVideosOfnewsLetterAndBlogs from "./components/allVideosOfnewsLetterAndBlogs";
import NewsletterUploadForm from "./components/newsletterUploadForm";
import NewsletterManager from "./components/newsletterManager";
import CategoryPage from "./components/categoryPage";
import DiscountsCouponsManager from "./components/DiscountCoupons";
import Strategies from "./components/strategies";
import StrategyUserDetails from "./components/StrategyUserDetails";
import ScrollProgressBar from "./components/ScrollProgressBar";
import SourceTechnicalData from "./components/sourceTechnicalData";
import AdHocQuarterlyAndYearly from "./components/adHocQuarterlyAndYearly";
import GetInTouchButton from "./components/GetInTouchButton";
import ExploreStrategies from "./components/exploreStrategies";
import CmsPage from "./components/CmsPage";
import LiveFilteredStocksPage from "./components/strategyRebalanceManager";
import Stocks from "./components/stocks";
import Portfolios from "./components/portfolio";
import StockIdeas from "./components/stockIdeas";
import Backtester from "./components/backtester";
import ScrollToTop from "./components/ScrollToTop";
import Policies from "./components/policies";
import Complaint from "./components/complaint";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SourceReportDetails from "./components/sourceReportDetails";
import AdHocIndividualSourcing from "./components/Ad-hoc-individualSourcing";
import SourceDailyWeeklyData from "./components/sourceDailyWeeklyData";
import DatabaseViewReport from "./components/databaseViewReport";
import PortfolioDetails from "./components/portfolioDetails";
import StrategyRebalancingPage from "./components/StrategyRebalancingPage";
import StrategyRebalancedManager from "./components/strategyRebalanceManager";
import LiveFilteredStocks from "./components/liveFliteredStocks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import AboutUs from './components/aboutUs';
// import Services from './components/services';
// import ContactUs from './components/contactUs';

const isAuthenticated = () => !!sessionStorage.getItem("jwtToken");

const AuthWrapper = ({ children }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  return children;
};

function App() {
  const hostname = window.location.hostname;
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      navigate("/", {
        replace: true,
        state: { sessionExpired: true },
      });
    };

    window.addEventListener("SESSION_EXPIRED", handler);
    return () => window.removeEventListener("SESSION_EXPIRED", handler);
  }, [navigate]);

  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        // || hostname === 'localhost'
        {hostname === "admin.bossinvestor.in" ||
        hostname === "admin.uat.bossinvestor.in" ||
        hostname === "localhost" ? (
          <>
            {/* Admin Login */}
            <Route path="/" element={<AuthPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route
              path="/*"
              element={
                <AuthWrapper>
                  <Routes>
                    <Route path="/homePage" element={<HomePage />} />
                    <Route
                      path="/exploreDataManager"
                      element={<ExploreDataManager />}
                    />
                    <Route
                      path="/addExploreData"
                      element={<AddExploreDataForm />}
                    />
                    <Route
                      path="/strategyDataManager/:strategyCode"
                      element={<StrategyDataManager />}
                    />
                    <Route
                      path="/liveStrategies"
                      element={<LiveStrategiesTable />}
                    />
                    <Route
                      path="/strategyDescriptionTable"
                      element={<StrategyDescriptionTable />}
                    />
                    <Route
                      path="/notificationDataManager"
                      element={<NotificationDataManager />}
                    />
                    <Route path="/refreshCache" element={<RefreshCache />} />
                    <Route
                      path="/notificationDataManager/email"
                      element={<NotificationDataManager type="Email" />}
                    />
                    {/* <Route path="/notificationDataManager/whatsapp" element={<NotificationDataManager type="WhatsApp" />} /> */}
                    <Route
                      path="/notificationDataManager/app"
                      element={<NotificationDataManager type="App" />}
                    />
                    <Route
                      path="/stockSplitCalender"
                      element={<StockSplitCalendar />}
                    />
                    <Route
                      path="/scheduleJobStatus"
                      element={<SchedulerAuditLogs />}
                    />
                    <Route path="/auditLogs" element={<AuditLogs />} />
                    <Route
                      path="/newsletterUploadForm"
                      element={<NewsletterUploadForm />}
                    />
                    <Route
                      path="/adHocQuarterlyAndYearly"
                      element={<AdHocQuarterlyAndYearly />}
                    />
                    <Route
                      path="/sourceTechnicalData"
                      element={<SourceTechnicalData />}
                    />
                    <Route
                      path="/sourceReportDetails"
                      element={<SourceReportDetails />}
                    />
                    <Route
                      path="/ad-hoc-individualSourcing"
                      element={<AdHocIndividualSourcing />}
                    />
                    <Route
                      path="/SourceDailyWeeklyData"
                      element={<SourceDailyWeeklyData />}
                    />
                    <Route
                      path="/databaseViewReport"
                      element={<DatabaseViewReport />}
                    />
                    <Route
                      path="/newsletterManager"
                      element={<NewsletterManager />}
                    />
                    <Route
                      path="/discountsCoupons"
                      element={<DiscountsCouponsManager />}
                    />
                    <Route path="/strategies" element={<Strategies />} />
                    <Route path="/stocks" element={<Stocks />} />
                    <Route
                      path="/strategyRebalanceManager"
                      element={<StrategyRebalancedManager />}
                    />
                    <Route
                      path="/strategy-user-details/:strategyCode"
                      element={<StrategyUserDetails />}
                    />
                    <Route
                      path="/strategyRebalancingPage"
                      element={<StrategyRebalancingPage />}
                    />
                    <Route
                      path="/LiveFilteredStocks"
                      element={<LiveFilteredStocks />}
                    />
                  </Routes>
                </AuthWrapper>
              }
            />
          </>
        ) : (
          <>
            {/* Public Routes */}
            <Route path="/home" element={<UnauthorizedHomePage />} />
            {/* <Route path="/unauthorizedExplorePage" element={<UnauthorizedExplorePage />} /> */}
            {/* <Route path="/contactUs" element={<UnauthorizedContactUs />} /> 
              <Route path="/aboutUs" element={<UnauthorizedAboutUs />} />
              <Route path="/services" element={<UnauthorizedServicePage />} /> */}
            {/* <Route path="/see-all" element={<SeeAllVideosPage />} /> */}
            <Route path="/blogs" element={<NewsLetterAndBlogs />} />
            <Route
              path="/blogs/:slug"
              element={<NewsLetterAndBlogsTemplate />}
            />
            {/* <Route path="/allVideosOfnewsLetterAndBlogs" element={<AllVideosOfnewsLetterAndBlogs />} /> */}
            {/* Redirect any other route to homepage */}
            <Route path="*" element={<Navigate to="/home" />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            {/* <Route path="/exploreStrategies" element={<ExploreStrategies />} /> */}
            <Route
              path="/privacy-policy"
              element={<CmsPage type="privacy" />}
            />
            <Route
              path="/terms-and-conditions"
              element={<CmsPage type="tnc" />}
            />
            {/* <Route path="/faq" element={<CmsPage type="faq" />} /> */}
            <Route path="/about" element={<CmsPage type="about" />} />
            <Route path="/contact" element={<CmsPage type="contact" />} />
            <Route path="/shipping" element={<CmsPage type="shipping" />} />
            <Route
              path="/cancellationrefunds"
              element={<CmsPage type="cancellationrefunds" />}
            />
            <Route
              path="/escalation_matrix"
              element={<CmsPage type="escalation_matrix" />}
            />
            <Route
              path="/investor_charter"
              element={<CmsPage type="investor_charter" />}
            />
            <Route
              path="/investor_monthly_complaints"
              element={<CmsPage type="investor_monthly_complaints" />}
            />
            <Route path="/model-portfolio" element={<Portfolios />} />
            <Route path="/stockIdeas" element={<StockIdeas />} />
            <Route path="/backtester" element={<Backtester />} />
            <Route path="/policies" element={<Policies />} />
            <Route
              path="/complianceredressal"
              element={<CmsPage type="complianceredressal" />}
            />
            <Route path="/portfolioDetails" element={<PortfolioDetails />} />
          </>
        )}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
